export default __webpack_public_path__ + "5937bd3e8d1b4d27914a25902a2e14bf.png";